export const handleVariantOptionsClick = () => {
  const { defaultVariant } = document.querySelector(
    '.product-variants-list'
  ).dataset;

  const priceLabel = document.querySelector(
    '.main-product-content .product-actual-price'
  );
  const comparePriceLabel = document.querySelector(
    '.main-product-content .product-compare-price'
  );
  const stickyPriceLabel = document.querySelector(
    '.sticky-cart .product-actual-price'
  );
  const stickyComparePriceLabel = document.querySelector(
    '.sticky-cart .product-compare-price'
  );
  const addToCartButton = document.querySelector('.atc-btn[data-add-to-cart]');
  const stickyAddToCartButton = document.querySelector(
    '.sticky-cart .atc-btn[data-add-to-cart]'
  );

  document.querySelectorAll('.variant-item').forEach((item) => {
    /* global addToCartText, soldOutText */

    const { variantId, available } = item.dataset;
    if (variantId === defaultVariant) {
      item.classList.add('active');
      if (
        available === 'true' &&
        item.classList.contains('product-details-variant')
      ) {
        addToCartButton.disabled = false;
        addToCartButton.querySelector(`span[data-addtocart-text]`).textContent =
          addToCartText;
      }
    }

    item.addEventListener('click', () => {
      const activeItems = document.querySelectorAll('.variant-item.active');
      if (activeItems) {
        activeItems.forEach((activeItem) => {
          activeItem.classList.remove('active');
        });
      }

      const variants = document.querySelectorAll('.variant-item');
      variants.forEach((variant) => {
        if (variant.dataset.variantId === variantId) {
          variant.classList.add('active');

          if (variant.classList.contains('product-variant')) {
            const price = (variant.dataset.price / 100).toFixed(2);
            const comparePrice = (variant.dataset.comparePrice / 100).toFixed(
              2
            );
            const priceWithCurrency = item.dataset.priceCurrency; // Sample price with currency symbol

            // Extract the first non-numeric part (symbol)
            const currencySymbol = priceWithCurrency.match(/^\D+/)[0].trim();

            // Update add to cart button text and disable/enable button based on availability
            if (available === 'false') {
              addToCartButton.disabled = true;
              addToCartButton.querySelector(
                `span[data-addtocart-text]`
              ).textContent = soldOutText;
              stickyAddToCartButton.disabled = true;
              stickyAddToCartButton.querySelector(
                `span[data-addtocart-text]`
              ).textContent = soldOutText;
            } else {
              addToCartButton.disabled = false;
              addToCartButton.querySelector(
                `span[data-addtocart-text]`
              ).textContent = addToCartText;
              stickyAddToCartButton.disabled = false;
              stickyAddToCartButton.querySelector(
                `span[data-addtocart-text]`
              ).textContent = addToCartText;
            }

            if (comparePrice > price) {
              comparePriceLabel.classList.remove('hidden');
              stickyComparePriceLabel.classList.remove('hidden');
              priceLabel.classList.add('compare-at-price');
              stickyPriceLabel.classList.add('compare-at-price');
            } else {
              comparePriceLabel.classList.add('hidden');
              stickyComparePriceLabel.classList.add('hidden');
              priceLabel.classList.remove('compare-at-price');
              stickyPriceLabel.classList.remove('compare-at-price');
            }
            priceLabel.innerHTML = `${currencySymbol}${price}`;
            stickyPriceLabel.innerHTML = `${currencySymbol}${price}`;

            comparePriceLabel.innerHTML = `${currencySymbol}${comparePrice}`;
            stickyComparePriceLabel.innerHTML = `${currencySymbol}${comparePrice}`;
          }
        }
      });
    });
  });
};
